import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import DropboxLogo from './DropboxLogo.vue'

export const dropboxIntegration: PreviewIntegration = {
  id: 'dropbox',
  name: 'Dropbox',
  description:
    'Integrate documents, presentations, and assets from Dropbox to give your AI a rich repository of work.',
  icon: DropboxLogo,
}
